import pluralize from "pluralize";
import memoize from "./memoize";

const _singular = word => pluralize.singular(word);
export const singular = memoize(_singular);

const _plural = word => pluralize(word);
export const plural = memoize(_plural);
